import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { AllWidgets, DeviceDetail } from "./";
import { ModalComp } from "../";
import { DeviceSection } from "../../context/DeviceContext";
import { useTranslation } from "react-i18next";

const WidgetsJoined = () => {
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const deviceWidgetsJoined = useSelector((state) => state.deviceWidgetsJoined);
  const [openDeviceDetails, setOpenDeviceDetails] = useState(false);
  const toggleDeviceDetails = () => setOpenDeviceDetails(!openDeviceDetails);
  const { t } = useTranslation();

  return (
    <>
      <ModalComp
        modal={openDeviceDetails}
        toggle={toggleDeviceDetails}
        component={<DeviceDetail />}
        dark={true}
      />
      <div
        className="d-flex flex-wrap justify-content-between"
        style={{ maxHeight: "65vh", overflow: "auto" }}
      >
        {deviceWidgetsJoined?.map((widget, index) => {
          if (widget["property"][3]) {
            return (
              <AllWidgets
                key={index}
                widget={widget}
                num={index + 1}
                toggleDeviceDetails={toggleDeviceDetails}
              />
            );
          }
        })}
      </div>
      <div className="d-flex flex-wrap justify-content-center mt-5">
        <button
          type="submit"
          className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ShowHideDeviceFunction("endPage")}
        >
          <span className="profileAddUser bg-white d-block icon-right cursor"></span>
          <small className="fn12 mt-1">{t("بعدی")}</small>
        </button>
        <div
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
          onClick={() => ShowHideDeviceFunction("allDevices")}
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn12 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </>
  );
};

export { WidgetsJoined };
